module.exports = __webpack_public_path__ + "static/media/articleMock.77ad1053.svg";